import {FRDataRetriever} from "#Formulas/FormulaCore/Elements/FRField/FRDataRetriever";


export abstract class FRBase{
    constructor(public Options:any,public Parent:FRBase) {
    }

    public get Retriever():FRDataRetriever{
        return this.Parent.Retriever;
    }

    public MaybeExecutePromise(result,nextCallBack:(result:any)=>any){
        if(result instanceof Promise)
            return new Promise(async (resolve,reject)=>{
                try {
                    let result2 = await result;
                    resolve(nextCallBack(result2));
                }catch (e) {
                    reject(e);
                }

            });
        else
            return nextCallBack(result);
    }

    public Iterate(items:any[],callBack:(item,index,onEnd:()=>any)=>void,onEnd:()=>any){
        let iterate=(items,index)=>{
            if(items.length>index)
            {
                let item=items[index].Parse();
                if(item instanceof Promise)
                {
                    return new Promise(async (resolve,reject)=>{
                        do{
                            if(item instanceof Promise)
                                try {
                                    item = await item;
                                }catch (e) {
                                    reject(e);
                                    return;
                                }

                            let wasEnded=false;
                            callBack(item,index,()=>{
                                wasEnded=true;
                                resolve(onEnd());
                                return;
                            })

                            if(wasEnded)
                                return;

                            if(index+1==items.length) {
                                resolve(onEnd());
                                return;
                            }
                            index++;
                            item=items[index].Parse();

                        }while(true);
                    });
                }else{
                    let wasEnded=false;
                    callBack(item,index,()=>{
                        wasEnded=true;
                    });
                    if(wasEnded)
                        return onEnd();

                    return iterate(items,index+1);
                }
            }else
                return onEnd();
        }
        return iterate(items,0);
    }

    public get Type():string{
        return this.Options.T;
    }

    public abstract Parse():any;
}